import { useFreshchat } from "@hooks/useFreshchat";
import { useEffect } from "react";
import Branch from "src/integrations/branch";
import Braze from "src/integrations/braze";
import Firebase from "src/integrations/firebase";
import GTM from "src/integrations/gtm";

export default function useIntegrations({ hideFreshchatWidget = false } = {}) {
	if (!process.env.NEXT_PUBLIC_IS_E2E_TEST) {
		useFreshchat({ hideWidget: hideFreshchatWidget });
	}
	useEffect(() => {
		if (!process.env.NEXT_PUBLIC_IS_E2E_TEST) {
			Braze.start();
			Branch.start();
			GTM.start();
			Firebase.start();
		}

		return () => {
			if (!process.env.NEXT_PUBLIC_IS_E2E_TEST) {
				Braze.stop();
				Branch.stop();
				GTM.stop();
				Firebase.stop();
			}
		};
	}, []);
}
